import { makeVar } from '@apollo/client';

export const showAuth = makeVar(false);
export const authPhoneLogin = makeVar('');
export const loginFallbackCallback = makeVar({});
export const authStage = makeVar('');
export const cartTotal = makeVar(-1);
